import React from 'react';
import { KTSVG } from 'src/_metronic/helpers';
import { useAppSelector } from 'src/services/redux/app/store';

// Dashboard görüntüleme yetkisi olmayan kullanıcılara gösterilen karşılama ekranı
const DashboardWelcome = () => {
  const { user } = useAppSelector((state: any) => state.auth);

  return (
    <div className="d-flex flex-column flex-center text-center p-10">
      <div className="card card-flush w-lg-650px py-5">
        <div className="card-body py-15 py-lg-20">
          <div className="mb-10 d-flex justify-content-center flex-row">
            <KTSVG path="/media/icons/duotone/General/Smile.svg" className="svg-icon svg-icon-5x svg-icon-primary" />
          </div>

          <h1 className="text-gray-800 mb-5">Hoşgeldiniz{user?.name ? `, ${user.name}` : ''}!</h1>

          <div className="fs-6 text-gray-500">
            AY-CRM'e hoş geldiniz.
            <br />
            Üst menüden yetkili olduğunuz sayfalara ulaşabilirsiniz.
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardWelcome;
